import { nameOfFactory } from "@libs/utils/name-of.utils.ts";
import { ClinicalRecord } from "@stores/clinical/models/ClinicalRecord.ts";

export interface InteractionTimeLineFilterState {
  search: string;
  types: string[];
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
}

export interface IInteractionTimeLineFilterProps {
  clinicalRecord: ClinicalRecord;
  onSearch: (filter: InteractionTimeLineFilterState) => void;
}

export const interactionTimeFilterNameOf =
  nameOfFactory<InteractionTimeLineFilterState>();
